import React from 'react';
import { string, shape, bool } from 'prop-types';

const SvgComponent = ({ className, colors, checked = true }) => (
  <svg
    viewBox="0 0 400 400"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="m200 400c110.46 0 200-89.54 200-200s-89.54-200-200-200-200 89.54-200 200 89.54 200 200 200z"
      fill={checked ? colors.brand.primary : '#E9EAEC'}
      fillRule="evenodd"
    />
    <g
      xmlns="http://www.w3.org/2000/svg"
      transform="matrix(0.875 0 0 0.875 0 0) translate(30,25)"
      fill={checked ? '#fff' : '#A4A8B2'}
    >
      <path
        transform="matrix(8 0 0 8 0 0)"
        d="M25.9035 38C 25.0529 38 24.3724 38 23.777 37.9148C 22.5012 37.8295 21.4805 36.9771 20.9701 35.5279C 18.0782 27.6853 19.6943 20.0984 20.5448 16.0066C 20.6299 15.4099 20.8 14.9836 20.8 14.5574C 21.1402 12.8525 22.7563 11.659 24.4575 11.9148C 24.7127 12 25.0529 12 25.3931 12.0853C 26.3287 12.2558 27.6046 12.4262 28.8805 12.682C 29.8161 12.8525 30.3264 13.7902 30.1563 14.6426C 29.9862 15.5803 29.1356 16.0918 28.2 15.9213C 26.9241 15.6656 25.8184 15.4951 24.7977 15.3246C 24.4262 15.2626 24.0322 15.3246 24.0322 15.3246C 23.9471 15.7508 23.8621 16.1771 23.777 16.7738C 23.0115 20.5246 21.5655 27.5148 24.0322 34.4197C 24.0322 34.5049 24.1173 34.5902 24.1173 34.5902C 27.1793 34.7607 34.154 34.6754 37.6414 30.6689C 38.2368 29.9869 39.2575 29.9017 40.023 30.4984C 40.7035 31.0951 40.7885 32.1181 40.1931 32.8853C 36.4506 37.2328 29.9862 38 25.9035 38z"
        stroke="none"
      />
      <path
        transform="matrix(8 0 0 8 0 0)"
        d="M38.3793 17.3246C 39.1448 17.1541 39.7402 16.4721 39.7402 15.7049C 39.7402 14.7672 38.9747 14 38.0391 14L38.0391 14L33.8713 14C 32.9356 14 32.2552 14.7672 32.1701 15.6197C 32.0851 15.7902 32 16.0459 32 16.3016L32 16.3016L32 19.6262C 32 20.5639 32.7655 21.3311 33.7011 21.3311C 34.6368 21.3311 35.4023 20.5639 35.4023 19.6262L35.4023 19.6262L35.4023 19.4557C 39.7402 22 40.1031 24.5 39.7402 26.5C 39.5701 27.4377 40.0805 28.2902 41.0161 28.4607C 41.1012 28.4607 41.2713 28.4607 41.3563 28.4607C 42.1218 28.4607 42.7189 27.9258 42.9724 27.182C 44.2275 23.5 42.2275 20 38.3793 17.3246z"
        stroke="none"
      />
      <path
        transform="matrix(8 0 0 8 0 0)"
        d="M7.70119 21.9737C 7.10578 21.9737 6.51038 21.6328 6.17015 21.036C 5.74486 20.1836 6.08509 19.2459 6.93567 18.8196L6.93567 18.8196L15.2713 14.6426C 16.0368 14.3016 17.0575 14.5573 17.4828 15.4098C 17.9081 16.2623 17.5679 17.2 16.7173 17.6262L16.7173 17.6262L8.38165 21.8033C 8.12647 21.9737 7.95636 21.9737 7.70119 21.9737z"
        stroke="none"
      />
      <path
        transform="matrix(8 0 0 8 0 0)"
        d="M7.70119 29.9016C 7.10578 29.9016 6.51038 29.5606 6.17015 28.9639C 5.74486 28.1114 6.08509 27.1737 6.93567 26.7475L6.93567 26.7475L15.2713 22.5705C 16.1219 22.1442 17.0575 22.4852 17.4828 23.3377C 17.9081 24.1901 17.5679 25.1278 16.7173 25.5541L16.7173 25.5541L8.38165 29.7311C 8.12647 29.9016 7.95636 29.9016 7.70119 29.9016z"
        stroke="none"
      />
      <path
        transform="matrix(8 0 0 8 0 0)"
        d="M7.70119 37.8296C 7.10578 37.8296 6.51038 37.4886 6.17015 36.8919C 5.74486 36.0394 6.08509 35.1017 6.93567 34.6755L6.93567 34.6755L15.2713 30.4984C 16.1219 30.0722 17.0575 30.4132 17.4828 31.2657C 17.9081 32.1181 17.5679 33.0558 16.7173 33.482L16.7173 33.482L8.38165 37.6591C 8.12647 37.7443 7.95636 37.8296 7.70119 37.8296z"
        stroke="none"
      />
    </g>
  </svg>
);

SvgComponent.propTypes = {
  className: string,
  colors: shape(),
  checked: bool,
};

export default SvgComponent;
